export default __webpack_public_path__ + "a06e879255f508104fea40add8c2202b.png";